import React, { useEffect, useState } from 'react'
import logo from '../../pbs-logo.svg'
import { getShowPoster } from '../../actions/contentActions'
import FocusableButtonTS from '../../components/FocusableButton/FocusableButtonTS'
import { useLocation, useNavigate } from 'react-router'
import {
  KeyTypeEnum,
  useKeyDown,
} from '../../../../shared/providers/KeyDownProvider'
import ExitAppModal from '../../components/ExitAppModal'
import tts from '../../lib/TTS'
import cx from 'classnames'

const ActivationScreen = () => {
  const [showExitAppModal, setShowExitAppModal] = useState(false)
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const [showPoster, setShowPoster] = useState<string>('')
  const navigate = useNavigate()
  const location = useLocation()

  useKeyDown(KeyTypeEnum.Back, () => {
    tts.stopRead()
    setShowExitAppModal(true)
  })

  // Workaround to allow new focus components to work with spatial navigation and old components work with focusable HoC
  // TODO: remove this when whole app is migrated to react spatial navigation
  useEffect(() => {
    window.focusedComponent = {}
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  useEffect(() => {
    getShowPoster()
      .then((poster) => {
        setShowPoster(poster ? `${poster}?format=webp` : '')
      })
      .catch((error) => {
        console.error('Error fetching show poster:', error)
      })
  }, [])

  const handleButtonEnter = () => {
    let url = '/activatecode'
    if (location.search !== '') {
      url += location.search
    }
    navigate(url)
  }

  const handleButtonFocus = () =>
    tts.addTextToRead(
      `Watch PBS anytime, anywhere. Discover full-length episodes and archived seasons. Access your personalized watchlist and favorite shows. Connect with your local PBS station. Sign In Button Focused`
    )

  return (
    <>
      {showExitAppModal ? (
        <ExitAppModal
          onCancel={() => setShowExitAppModal(false)}
          withoutLogoHeader={true}
        />
      ) : (
        <div className="activation-screen">
          <div className="activation-screen__content-wrapper">
            <div className="activation-screen__content">
              <img
                className="activation-screen__logo"
                src={logo}
                alt="PBS Logo"
              />
              <h1 className="activation-screen__title">
                Watch PBS anytime, anywhere.
              </h1>
              <p className="activation-screen__description">
                Discover full-length episodes and archived seasons.
                <br />
                Access your personalized watchlist and favorite shows.
                <br />
                Connect with your local PBS station.
              </p>
              <FocusableButtonTS
                className="activation-screen__sign-in-button"
                stealFocus={true}
                onEnterPress={handleButtonEnter}
                onFocus={handleButtonFocus}
              >
                Sign In
              </FocusableButtonTS>
            </div>
          </div>
          <img
            className={cx('activation-screen__show-poster', {
              'activation-screen__show-poster--loading': !isImageLoaded,
            })}
            src={showPoster}
            onLoad={() => setIsImageLoaded(true)}
          />
        </div>
      )}
    </>
  )
}

export default ActivationScreen
